import React, { useState, useEffect, useRef } from 'react';
import './SproutLoader.css';

const STEPS = [
  { label: 'Loading your workspace', at: 0 },
  { label: 'Fetching applications', at: 50 },
];

function SproutLoader() {
  const [progress, setProgress] = useState(0);
  const [stepLabel, setStepLabel] = useState(STEPS[0].label);
  const timerRef = useRef(null);

  useEffect(() => {
    let currentProgress = 0;
    const totalMs = 2800;
    const stepMs = 30;
    const increment = 100 / (totalMs / stepMs);

    timerRef.current = setInterval(() => {
      currentProgress = Math.min(100, currentProgress + increment);
      setProgress(currentProgress);

      const currentStep = [...STEPS].reverse().find(s => currentProgress >= s.at);
      if (currentStep) setStepLabel(currentStep.label);

      if (currentProgress >= 100) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }, stepMs);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return (
    <div className="sprout-loader-stage">
      {/* Background grid */}
      <div className="sprout-loader-grid"></div>

      {/* Ambient blobs */}
      <div className="sprout-loader-blob sl-b1"></div>
      <div className="sprout-loader-blob sl-b2"></div>

      {/* Center content */}
      <div className="sprout-loader-inner">
        {/* Growing sprout SVG */}
        <svg
          className="sprout-loader-svg"
          viewBox="0 0 76 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <ellipse className="sl-seed" cx="38" cy="90" rx="10" ry="5" fill="#0B4C8C" />
          <path className="sl-stem" d="M38 90V26" stroke="#8AD980" strokeWidth="4" strokeLinecap="round" />
          <path className="sl-leaf sl-leaf-l" d="M38 50C38 50 12 46 12 20C12 20 38 16 38 50Z" fill="#4AB83F" />
          <path className="sl-leaf sl-leaf-r" d="M38 62C38 62 64 59 64 34C64 34 38 30 38 62Z" fill="#8AD980" />
        </svg>

        {/* Step text */}
        <p className="sprout-loader-text">{stepLabel}</p>

        {/* Progress bar */}
        <div className="sprout-loader-track">
          <div
            className="sprout-loader-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default SproutLoader;
